import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/nft-10.png'
import _imports_1 from '@/assets/images/user-76.gif'
import _imports_2 from '@/assets/images/verify.svg'
import _imports_3 from '@/assets/images/nft-11.png'
import _imports_4 from '@/assets/images/user-77.gif'
import _imports_5 from '@/assets/images/nft-12.png'
import _imports_6 from '@/assets/images/user-85.png'
import _imports_7 from '@/assets/images/nft-14.png'
import _imports_8 from '@/assets/images/nft-3.gif'
import _imports_9 from '@/assets/images/nft-15.png'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "all-items-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "all-items-tab",
  tabindex: "0"
}
const _hoisted_5 = { class: "row justify-content-center" }
const _hoisted_6 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_7 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_10 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_11 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_13 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_14 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_15 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_16 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_18 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_19 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_21 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_22 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_23 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_24 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_25 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_26 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_27 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_28 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_29 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_30 = { class: "col-lg-12" }
const _hoisted_31 = {
  class: "tab-pane fade",
  id: "up-to-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "up-to-tab",
  tabindex: "0"
}
const _hoisted_32 = { class: "row justify-content-center" }
const _hoisted_33 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_34 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_35 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_36 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_37 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_38 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_39 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_40 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_41 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_42 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_43 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_44 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_45 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_46 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_47 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_48 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_49 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_50 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_51 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_52 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_53 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_54 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_55 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_56 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_57 = { class: "col-lg-12" }
const _hoisted_58 = {
  class: "tab-pane fade",
  id: "up-to-two-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "up-to-two-tab",
  tabindex: "0"
}
const _hoisted_59 = { class: "row justify-content-center" }
const _hoisted_60 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_61 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_62 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_63 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_64 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_65 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_66 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_67 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_68 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_69 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_70 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_71 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_72 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_73 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_74 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_75 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_76 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_77 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_78 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_79 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_80 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_81 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_82 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_83 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_84 = { class: "col-lg-12" }
const _hoisted_85 = {
  class: "tab-pane fade",
  id: "up-to-three-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "up-to-three-tab",
  tabindex: "0"
}
const _hoisted_86 = { class: "row justify-content-center" }
const _hoisted_87 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_88 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_89 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_90 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_91 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_92 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_93 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_94 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_95 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_96 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_97 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_98 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_99 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_100 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_101 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_102 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_103 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_104 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_105 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_106 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_107 = { class: "col-xxl-4 col-sm-6" }
const _hoisted_108 = { class: "bg-white rounded-3 border-0 p-3 place-bid for-dark-card mb-4" }
const _hoisted_109 = { class: "d-flex justify-content-between align-items-center border-bottom pb-3 mb-3" }
const _hoisted_110 = { class: "d-flex justify-content-between align-items-center mb-4 pb-2" }
const _hoisted_111 = { class: "col-lg-12" }
const _hoisted_112 = { class: "col-lg-4 col-xxl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountdownTimer = _resolveComponent("CountdownTimer")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_NewMobileApp = _resolveComponent("NewMobileApp")!
  const _component_HistoryOfBids = _resolveComponent("HistoryOfBids")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[192] || (_cache[192] = _createElementVNode("div", { class: "card border-0 bg-white p-4 mb-4" }, [
        _createElementVNode("div", { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center" }, [
          _createElementVNode("h3", { class: "mb-0 fs-18" }, "Live Auction"),
          _createElementVNode("ul", {
            class: "nav nav-tabs live-auction gap-2 gap-md-4 border-0 bg-transparent",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link fs-12 fw-medium text-body bg-transparent border-0 active",
                id: "all-items-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#all-items-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "all-items-tab-pane",
                "aria-selected": "true"
              }, " ALL ITEMS (12) ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link fs-12 fw-medium text-body bg-transparent border-0",
                id: "up-to-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#up-to-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "up-to-tab-pane",
                "aria-selected": "false"
              }, " UP TO 15%(05) ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link fs-12 fw-medium text-body bg-transparent border-0",
                id: "up-to-two-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#up-to-two-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "up-to-two-tab-pane",
                "aria-selected": "false"
              }, " UP TO 30%(07) ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link fs-12 fw-medium text-body bg-transparent border-0",
                id: "up-to-three-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#up-to-three-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "up-to-three-tab-pane",
                "aria-selected": "false"
              }, " UP TO 50%(05) ")
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createElementVNode("img", {
                      src: _imports_0,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35246"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Christmas Eve")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode(" Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, " 9.75 ETH ")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "5.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode(" 9.2 "),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "50",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"50%","height":"4px"}
                  })
                ], -1)),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[8] || (_cache[8] = _createElementVNode("img", {
                      src: _imports_3,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "January 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35247"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Humming Bird")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[11] || (_cache[11] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[13] || (_cache[13] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.5"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "60",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"60%","height":"4px"}
                  })
                ], -1)),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[16] || (_cache[16] = _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "February 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35228"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Naughty Pool")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[19] || (_cache[19] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "8.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "9.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[21] || (_cache[21] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[22] || (_cache[22] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "70",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"70%","height":"4px"}
                  })
                ], -1)),
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[24] || (_cache[24] = _createElementVNode("img", {
                      src: _imports_7,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "February 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35248"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Pixel Watermmelon")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[27] || (_cache[27] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "1.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "3.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[29] || (_cache[29] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[30] || (_cache[30] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "60",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"60%","height":"4px"}
                  })
                ], -1)),
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[32] || (_cache[32] = _createElementVNode("img", {
                      src: _imports_8,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[33] || (_cache[33] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35258"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "BDancing Cookies")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[35] || (_cache[35] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[37] || (_cache[37] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[38] || (_cache[38] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "50",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"50%","height":"4px"}
                  })
                ], -1)),
                _cache[39] || (_cache[39] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[40] || (_cache[40] = _createElementVNode("img", {
                      src: _imports_9,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[41] || (_cache[41] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35158"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Rotating Flower")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[43] || (_cache[43] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "3.95 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "6.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[45] || (_cache[45] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode(" 9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[46] || (_cache[46] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "75",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"75%","height":"4px"}
                  })
                ], -1)),
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_Pagination, {
                items: "6",
                total: "30",
                class: "mb-4"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[48] || (_cache[48] = _createElementVNode("img", {
                      src: _imports_7,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[49] || (_cache[49] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "February 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35248"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Pixel Watermmelon")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[51] || (_cache[51] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "1.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "3.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[53] || (_cache[53] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[54] || (_cache[54] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "60",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"60%","height":"4px"}
                  })
                ], -1)),
                _cache[55] || (_cache[55] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[56] || (_cache[56] = _createElementVNode("img", {
                      src: _imports_8,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[57] || (_cache[57] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35258"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "BDancing Cookies")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[59] || (_cache[59] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[61] || (_cache[61] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[62] || (_cache[62] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "50",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"50%","height":"4px"}
                  })
                ], -1)),
                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[64] || (_cache[64] = _createElementVNode("img", {
                      src: _imports_9,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[65] || (_cache[65] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35158"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Rotating Flower")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[67] || (_cache[67] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "3.95 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "6.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[69] || (_cache[69] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[70] || (_cache[70] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "75",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"75%","height":"4px"}
                  })
                ], -1)),
                _cache[71] || (_cache[71] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[72] || (_cache[72] = _createElementVNode("img", {
                      src: _imports_0,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[73] || (_cache[73] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_47, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35246"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Christmas Eve")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[75] || (_cache[75] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "9.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "5.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[77] || (_cache[77] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.2"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[78] || (_cache[78] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "50",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"50%","height":"4px"}
                  })
                ], -1)),
                _cache[79] || (_cache[79] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[80] || (_cache[80] = _createElementVNode("img", {
                      src: _imports_3,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[81] || (_cache[81] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "January 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35247"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Humming Bird")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[83] || (_cache[83] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[85] || (_cache[85] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.5"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[86] || (_cache[86] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "60",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"60%","height":"4px"}
                  })
                ], -1)),
                _cache[87] || (_cache[87] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[88] || (_cache[88] = _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[89] || (_cache[89] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "February 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35228"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Naughty Pool")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[91] || (_cache[91] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "8.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "9.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[93] || (_cache[93] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[94] || (_cache[94] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "70",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"70%","height":"4px"}
                  })
                ], -1)),
                _cache[95] || (_cache[95] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createVNode(_component_Pagination, {
                items: "6",
                total: "30",
                class: "mb-4"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[96] || (_cache[96] = _createElementVNode("img", {
                      src: _imports_0,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[97] || (_cache[97] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_62, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35246"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Christmas Eve")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[99] || (_cache[99] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "9.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "5.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[101] || (_cache[101] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.2"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[102] || (_cache[102] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "50",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"50%","height":"4px"}
                  })
                ], -1)),
                _cache[103] || (_cache[103] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[104] || (_cache[104] = _createElementVNode("img", {
                      src: _imports_3,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[105] || (_cache[105] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "January 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[106] || (_cache[106] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35247"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Humming Bird")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[107] || (_cache[107] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[109] || (_cache[109] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.5"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[110] || (_cache[110] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "60",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"60%","height":"4px"}
                  })
                ], -1)),
                _cache[111] || (_cache[111] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[112] || (_cache[112] = _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[113] || (_cache[113] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "February 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35228"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Naughty Pool")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[115] || (_cache[115] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[116] || (_cache[116] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "8.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "9.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[117] || (_cache[117] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[118] || (_cache[118] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "70",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"70%","height":"4px"}
                  })
                ], -1)),
                _cache[119] || (_cache[119] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[120] || (_cache[120] = _createElementVNode("img", {
                      src: _imports_7,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[121] || (_cache[121] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "February 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[122] || (_cache[122] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35248"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Pixel Watermmelon")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[123] || (_cache[123] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[124] || (_cache[124] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "1.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "3.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[125] || (_cache[125] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[126] || (_cache[126] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "60",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"60%","height":"4px"}
                  })
                ], -1)),
                _cache[127] || (_cache[127] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[128] || (_cache[128] = _createElementVNode("img", {
                      src: _imports_8,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[129] || (_cache[129] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_78, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[130] || (_cache[130] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35258"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "BDancing Cookies")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[131] || (_cache[131] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[132] || (_cache[132] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[133] || (_cache[133] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[134] || (_cache[134] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "50",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"50%","height":"4px"}
                  })
                ], -1)),
                _cache[135] || (_cache[135] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[136] || (_cache[136] = _createElementVNode("img", {
                      src: _imports_9,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[137] || (_cache[137] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_82, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[138] || (_cache[138] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35158"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Rotating Flower")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[139] || (_cache[139] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[140] || (_cache[140] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "3.95 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "6.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[141] || (_cache[141] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[142] || (_cache[142] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "75",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"75%","height":"4px"}
                  })
                ], -1)),
                _cache[143] || (_cache[143] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createVNode(_component_Pagination, {
                items: "6",
                total: "30",
                class: "mb-4"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[144] || (_cache[144] = _createElementVNode("img", {
                      src: _imports_7,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[145] || (_cache[145] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "February 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_89, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[146] || (_cache[146] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35248"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Pixel Watermmelon")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[147] || (_cache[147] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[148] || (_cache[148] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "1.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "3.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[149] || (_cache[149] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[150] || (_cache[150] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "60",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"60%","height":"4px"}
                  })
                ], -1)),
                _cache[151] || (_cache[151] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[152] || (_cache[152] = _createElementVNode("img", {
                      src: _imports_8,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[153] || (_cache[153] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_93, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[154] || (_cache[154] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35258"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "BDancing Cookies")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[155] || (_cache[155] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[156] || (_cache[156] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[157] || (_cache[157] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[158] || (_cache[158] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "50",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"50%","height":"4px"}
                  })
                ], -1)),
                _cache[159] || (_cache[159] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[160] || (_cache[160] = _createElementVNode("img", {
                      src: _imports_9,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[161] || (_cache[161] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_97, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[162] || (_cache[162] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35158"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Rotating Flower")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[163] || (_cache[163] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[164] || (_cache[164] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "3.95 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "6.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[165] || (_cache[165] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[166] || (_cache[166] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "75",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"75%","height":"4px"}
                  })
                ], -1)),
                _cache[167] || (_cache[167] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[168] || (_cache[168] = _createElementVNode("img", {
                      src: _imports_0,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[169] || (_cache[169] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "December 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_101, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[170] || (_cache[170] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35246"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Christmas Eve")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[171] || (_cache[171] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[172] || (_cache[172] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "9.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "5.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[173] || (_cache[173] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.2"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[174] || (_cache[174] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "50",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"50%","height":"4px"}
                  })
                ], -1)),
                _cache[175] || (_cache[175] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[176] || (_cache[176] = _createElementVNode("img", {
                      src: _imports_3,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[177] || (_cache[177] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "January 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_105, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[178] || (_cache[178] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35247"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Humming Bird")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[179] || (_cache[179] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[180] || (_cache[180] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode("Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, "10.75 ETH")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "12.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[181] || (_cache[181] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode("9.5"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[182] || (_cache[182] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "60",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"60%","height":"4px"}
                  })
                ], -1)),
                _cache[183] || (_cache[183] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("div", _hoisted_108, [
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "d-block mb-3 text-decoration-none position-relative"
                }, {
                  default: _withCtx(() => [
                    _cache[184] || (_cache[184] = _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-3",
                      alt: "nft"
                    }, null, -1)),
                    _cache[185] || (_cache[185] = _createElementVNode("span", { class: "btn btn-primary py-2 px-3 d-inline-block fs-16 fw-medium position-absolute top-50 start-50 translate-middle opacity-0" }, " Place Bid ", -1)),
                    _createVNode(_component_CountdownTimer, { endDate: "February 14, 2026 21:14:01" })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_109, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/creator-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[186] || (_cache[186] = [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "rounded-circle",
                          style: {"width":"27px","height":"27px"},
                          alt: "user"
                        })
                      ], -1),
                      _createElementVNode("div", { class: "flex-grow-1 ms-2" }, [
                        _createElementVNode("span", { class: "fs-12" }, "NFT ID: 35228"),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "Naughty Pool")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[187] || (_cache[187] = _createElementVNode("img", {
                    src: _imports_2,
                    class: "cursor",
                    alt: "verify",
                    "data-bs-toggle": "tooltip",
                    "data-bs-placement": "top",
                    "data-bs-title": "Verified"
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_110, [
                  _createVNode(_component_RouterLink, {
                    to: "/nft-marketplace/nft-details",
                    class: "d-flex align-items-center text-decoration-none"
                  }, {
                    default: _withCtx(() => [...(_cache[188] || (_cache[188] = [
                      _createElementVNode("div", { class: "flex-grow-1" }, [
                        _createElementVNode("span", { class: "fs-12 d-block mb-1" }, [
                          _createTextVNode(" Highest Bid: "),
                          _createElementVNode("span", { class: "fw-semibold text-secondary" }, " 8.75 ETH ")
                        ]),
                        _createElementVNode("h4", { class: "fw-semibold fs-14 mb-0" }, "9.50 ETH")
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[189] || (_cache[189] = _createElementVNode("button", { class: "bg-transparent p-0 border-0" }, [
                    _createElementVNode("i", {
                      class: "ri-heart-fill fs-20 position-relative top-2",
                      style: {"color":"#ee3e08"}
                    }),
                    _createElementVNode("span", { class: "text-secondary fs-12 fw-semibold" }, [
                      _createTextVNode(" 9.7"),
                      _createElementVNode("span", { class: "text-body" }, "/10")
                    ])
                  ], -1))
                ]),
                _cache[190] || (_cache[190] = _createElementVNode("div", {
                  class: "progress rounded-0 mb-2",
                  style: {"height":"4px"},
                  role: "progressbar",
                  "aria-label": "Primary example",
                  "aria-valuenow": "70",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-primary rounded-0",
                    style: {"width":"70%","height":"4px"}
                  })
                ], -1)),
                _cache[191] || (_cache[191] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
                  _createElementVNode("span", { class: "fs-12" }, "Sold: 130"),
                  _createElementVNode("span", { class: "fs-12" }, "Available: 123")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_111, [
              _createVNode(_component_Pagination, {
                items: "6",
                total: "30",
                class: "mb-4"
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_112, [
      _createVNode(_component_NewMobileApp),
      _createVNode(_component_HistoryOfBids)
    ])
  ]))
}